import * as signalR from '@microsoft/signalr';
import { apiUrl } from '@server';

// Синглтон real-time подключения к ChatHub (/hubs/chat).
// joinCompany(sessionId, handlers) — подписка на события компании:
//   onReceiveMessage(dto), onMessageDeleted({dialogId, messageId}), onDialogChanged({dialogId}), onDialogDeleted({dialogId}), onIncomingCall(dto), onConnectionStateChange(bool)
class DialogSignalRService {
    constructor() {
        this.connection = null;
        this.sessionId = null;
        this.handlers = {};
    }

    async joinCompany(sessionId, handlers = {}) {
        this.handlers = { ...this.handlers, ...handlers };
        this.sessionId = sessionId;

        if (!this.connection) {
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl(`${apiUrl}/hubs/chat`, {
                    skipNegotiation: true,
                    transport: signalR.HttpTransportType.WebSockets,
                })
                .withAutomaticReconnect([0, 2000, 5000, 10000])
                .configureLogging(signalR.LogLevel.Error)
                .build();

            this.connection.on('ReceiveMessage', (dto) => this.handlers.onReceiveMessage?.(dto));
            this.connection.on('MessageDeleted', (dto) => this.handlers.onMessageDeleted?.(dto));
            this.connection.on('DialogChanged', (dto) => this.handlers.onDialogChanged?.(dto));
            this.connection.on('DialogDeleted', (dto) => this.handlers.onDialogDeleted?.(dto));
            this.connection.on('IncomingCall', (dto) => this.handlers.onIncomingCall?.(dto));
            this.connection.on('Error', (err) => this.handlers.onError?.(new Error(err)));

            this.connection.onreconnecting(() => this.handlers.onConnectionStateChange?.(false));
            this.connection.onclose(() => this.handlers.onConnectionStateChange?.(false));
            this.connection.onreconnected(() => {
                this.handlers.onConnectionStateChange?.(true);
                // Группа компании после реконнекта теряется — входим заново
                if (this.sessionId) {
                    this.connection.invoke('JoinCompany', this.sessionId).catch(() => {});
                }
            });
        }

        if (this.connection.state === signalR.HubConnectionState.Disconnected) {
            await this.connection.start();
        }
        await this.connection.invoke('JoinCompany', sessionId);
    }

    async stop() {
        if (!this.connection) return;
        try {
            await this.connection.stop();
        } catch {
            // ignore
        }
        this.connection = null;
        this.sessionId = null;
    }
}

const dialogSignalR = new DialogSignalRService();
export default dialogSignalR;
